import {
    DELETE_MEMBERSHIP_SCHEDULE,
    DELETE_MEMBERSHIP_SCHEDULE_FAILURE,
    DELETE_MEMBERSHIP_SCHEDULE_SUCCESS,
} from 'store/actions/types';

export const deleteMembershipSchedule = (payload) => {
    return {
        type: DELETE_MEMBERSHIP_SCHEDULE,
        payload: payload,
    };
};

export const deleteMembershipScheduleFailure = (error) => {
    return {
        type: DELETE_MEMBERSHIP_SCHEDULE_FAILURE,
        error: error,
    };
};

export const deleteMembershipScheduleSuccess = (payload) => {
    return {
        type: DELETE_MEMBERSHIP_SCHEDULE_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-schedules/deleteMembershipSchedules.js